module.exports = __webpack_public_path__ + "static/media/1f4bc.3ff8ae91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f4bc.svg
// module id = 632
// module chunks = 1